export default "__VITE_ASSET__$nOJ5wgV__"